module.exports = __webpack_public_path__ + "img/42.9d614811.jpg";